__turbopack_context__.v({
  "header": "featured-products-module__--ejpq__header",
  "subtitle": "featured-products-module__--ejpq__subtitle",
  "title": "featured-products-module__--ejpq__title",
});
